import {IBaseFormFieldSettings} from "../base-form-field.settings";
import {MatDatetimepickerType} from "@mat-datetimepicker/core/datetimepicker/datetimepicker-type";


export interface IDateTimeFieldSettings extends IBaseFormFieldSettings {
  type?: MatDatetimepickerType;
}
